export const globals = {
    renderData: { keys: {}, cases: {}, mats: {}, uiOutlines: {} }, // derived
    pcbData: {}, // derived
    keyAssets: {}
}